import './Filter.scss';

import React from 'react';
import moment from 'moment';
import EditIcon from '@mui/icons-material/EditSharp';
import { ClickAwayListener } from '@mui/material';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useTranslation } from 'src/i18n';

const DEFAULT_START = () => moment().subtract(3, 'months');
const DEFAULT_END = () => moment();

interface DateFilterProps {
  type: 'startDate' | 'endDate';
  value: moment.Moment;
  onChange: (date: moment.Moment) => void;
  minDate?: moment.Moment;
  maxDate?: moment.Moment;
}

export default function DateFilter ({ type, value, onChange, minDate, maxDate }: DateFilterProps) {
  const { t } = useTranslation();
  const [edit, setEdit] = React.useState(false);

  const defaultValue = type === 'startDate' ? DEFAULT_START() : DEFAULT_END();
  const isDefault = value.isSame(defaultValue, 'day');

  const label = t(`filters.${type}`);
  const displayValue = value.format('MMM D, YYYY');

  const handleChange = (date: moment.Moment | null) => {
    onChange(date ?? defaultValue);
    setEdit(false);
  };

  const handleClickAway = () => {
    setEdit(false);
  };

  return (
    <div>
      <div className='filter-container'>
        <div className='label'>{label}</div>
        <div className='value'>
          {edit ? (
            <ClickAwayListener onClickAway={handleClickAway}>
              <div style={{ padding: '1px' }}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    disableFuture
                    value={value}
                    onChange={handleChange}
                    minDate={minDate}
                    maxDate={maxDate}
                    sx={{ width: 145 }}
                    slotProps={{
                      textField: { size: 'small' },
                      field: { clearable: true, onClear: () => { onChange(defaultValue); setEdit(false); } },
                    }}
                  />
                </LocalizationProvider>
              </div>
            </ClickAwayListener>
          ) : (
            <span>
              <span className={`text${isDefault ? ' default' : ''}`}>{displayValue}</span>
              <EditIcon className='icon' onClick={() => setEdit(true)} />
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
